import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, OperatorFunction, from } from 'rxjs';
import { TenentContextService } from './tenent-context.service';
import { filter, tap, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TenentIdentifierInterceptor implements HttpInterceptor {
  constructor(private tenantService: TenentContextService) { 
    console.log('TenentIdentifierInterceptor initialized');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.tenantService.addTenantToHeaders(request.headers)).pipe(
      switchMap((headers) => {
        const modifiedRequest = request.clone({
          headers: headers
        });

        return next.handle(modifiedRequest);
      })
    ).pipe(
      filter(event => event instanceof HttpResponse) as OperatorFunction<HttpEvent<any>, HttpResponse<any>>,
      tap((event: HttpResponse<any>) => {
      }),
    );
  }
}
